import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GatewayCommissioningStore, InstallationDetailsStore, InvitationsStore } from '@store';

import { PATTERN } from '../../../../../shared/common/constants';

@Component({
  selector: 'app-transfer-installation-dialog',
  templateUrl: './transfer-installation-dialog.component.html',
  styleUrls: ['./transfer-installation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferInstallationDialogComponent implements OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();
  private installationId: number;

  email: string;
  emailPattern = PATTERN.EMAIL;

  constructor(
    private installationDetailsStore: InstallationDetailsStore,
    private dialogRef: MatDialogRef<TransferInstallationDialogComponent>,
    public gatewayCommissioningStore: GatewayCommissioningStore,
    private invitationsStore: InvitationsStore
  ) {}

  ngOnInit(): void {
    this.subscribeToInstallationId();
    this.invitationsStore.listPendingTransferInstallationInvitations(this.installationId);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  sendInvitation(): void {
    this.gatewayCommissioningStore.sendInvitationToTransferOwnership({
      inviteeEmail: this.email,
      installationId: this.installationId,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private subscribeToInstallationId(): void {
    this.installationDetailsStore.getInstallationId$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((installationId) => {
        this.installationId = installationId;
      });
  }
}
